<template>
  <div class="wrapper">
    <SideBar
      v-if="!printMode"
      :links="currentCv.links"
      :cv="currentCv.cv"
      :lang="lang"
      :printMode="printMode"
    />
    <div class="resume" :class="{ 'resume--printmode': printMode }">
      <!-- Swiss accent elements -->
      <div class="accent-line"></div>
      <div class="geometric-accent"></div>

      <div class="container">
        <!-- Header with contact info -->
        <Heading :heading="currentCv.heading">
          <template #contact>
            <div v-for="(c, i) in currentCv.contact" :key="i" class="contact-line">
              {{ c.display }}
            </div>
          </template>
        </Heading>

        <!-- Two column grid for desktop -->
        <div class="desktop">
          <!-- Left Column -->
          <div class="left-column">
            <div class="section-number">(01)</div>
            <Experience :jobs="currentCv.jobs" />
            
            <div class="section-number">(02)</div>
            <Education :courses="currentCv.studies" />
          </div>

          <!-- Right Column -->
          <div class="right-column">
            <div class="section-number">(03)</div>
            <Skills :skills="currentCv.skills" />
            
            <div class="section-number">(04)</div>
            <Craft :craft="currentCv.craft" />
          </div>
        </div>

        <!-- Mobile layout -->
        <div class="mobile">
          <div class="section-number">(01)</div>
          <Experience :jobs="currentCv.jobs" />
          
          <div class="section-number">(02)</div>
          <Education :courses="currentCv.studies" />
          
          <div class="section-number">(03)</div>
          <Skills :skills="currentCv.skills" />
          
          <div class="section-number">(04)</div>
          <Craft :craft="currentCv.craft" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "./SideBar.vue";
import Heading from "./Heading";
import Skills from "./Skills";
import Craft from "./Craft";
import Experience from "./Experience";
import Education from "./Education";

import CV from "../data";

export default {
  name: "Resume",
  components: {
    SideBar,
    Heading,
    Skills,
    Craft,
    Experience,
    Education,
  },
  metaInfo() {
    return this.currentCv.meta;
  },
  data() {
    return {
      cv: CV,
      lang: "en",
      printMode: false,
    };
  },
  mounted() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    this.printMode = params.printmode;
  },
  created() {
    this.lang = this.$route.params.locale;
    document.documentElement.lang = this.lang;
  },
  watch: {
    $route() {
      this.lang = this.$route.params.locale;
      document.documentElement.lang = this.lang;
    },
  },
  computed: {
    currentCv() {
      return this.cv.languages[this.lang];
    },
  },
};
</script>

<style scoped>
.wrapper {
  position: relative;
}

.resume {
  width: 210mm;
  min-height: 297mm;
  background: white;
  position: relative;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: auto;
  gap: 0;
  padding: 20mm;
  box-sizing: border-box;
}

.resume--printmode {
  filter: none;
}

/* Red vertical line - classic Swiss accent */
.accent-line {
  position: absolute;
  width: 2px;
  height: 100%;
  background: #ff0000;
  left: 40mm;
  top: 0;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

/* Geometric accent element */
.geometric-accent {
  position: absolute;
  width: 15mm;
  height: 15mm;
  background: #ff0000;
  top: 85mm;
  right: 20mm;
  z-index: -1;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.container {
  grid-column: 1 / 13;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 0;
}

.contact-line {
  font-size: 8pt;
  line-height: 1.5;
}

/* Section numbers */
.section-number {
  font-size: 9pt;
  color: #666;
  margin-bottom: 3mm;
  margin-top: 8mm;
  font-weight: 400;
  letter-spacing: 1px;
}

.section-number:first-of-type {
  margin-top: 0;
}

/* Two column grid */
.desktop {
  grid-column: 1 / 13;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10mm;
}

.left-column {
  padding-right: 5mm;
}

.right-column {
  padding-left: 5mm;
  border-left: 1px solid #000;
}

.mobile {
  display: none;
  grid-column: 1 / 13;
}

@media screen and (max-width: 240mm) {
  .wrapper {
    padding: 10mm 0;
  }
  
  .resume {
    height: auto;
    min-height: unset;
  }
}

@media screen and (max-width: 202mm) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }
  
  .resume {
    padding: 10mm;
  }
  
  .accent-line,
  .geometric-accent {
    display: none;
  }
}
</style>
